import { createAction } from 'redux-actions';

export const constants = {
  setAppConfig: 'app.set_app_config',
};


export const actions = Object
  .keys(constants)
  .reduce((res, key) =>
    Object.assign(res, { [key]: createAction(constants[key]) }), {});
